// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b88aefb8","667":"64e5f5fc","977":"91250ca0"}[chunkId] + ".chunk.js";
};